import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { Field } from "react-final-form";
import { CheckboxInput } from "@vk-hr-tek/ui/input";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function CheckboxInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else CheckboxInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const CheckboxInput_CheckboxInput = (t0)=>{
    const $ = c(28);
    let checkboxTooltip;
    let disabled;
    let label;
    let labelColor;
    let labelIcon;
    let labelPlacement;
    let labelVariant;
    let name;
    let onChange;
    let rest;
    let testId;
    let tooltip;
    if ($[0] !== t0) {
        ({ label, labelIcon, labelPlacement, labelColor, labelVariant, name, tooltip, checkboxTooltip, disabled, onChange, testId } = t0), rest = _object_without_properties(t0, [
            "label",
            "labelIcon",
            "labelPlacement",
            "labelColor",
            "labelVariant",
            "name",
            "tooltip",
            "checkboxTooltip",
            "disabled",
            "onChange",
            "testId"
        ]);
        $[0] = t0;
        $[1] = checkboxTooltip;
        $[2] = disabled;
        $[3] = label;
        $[4] = labelColor;
        $[5] = labelIcon;
        $[6] = labelPlacement;
        $[7] = labelVariant;
        $[8] = name;
        $[9] = onChange;
        $[10] = rest;
        $[11] = testId;
        $[12] = tooltip;
    } else {
        checkboxTooltip = $[1];
        disabled = $[2];
        label = $[3];
        labelColor = $[4];
        labelIcon = $[5];
        labelPlacement = $[6];
        labelVariant = $[7];
        name = $[8];
        onChange = $[9];
        rest = $[10];
        testId = $[11];
        tooltip = $[12];
    }
    let t1;
    if ($[13] !== checkboxTooltip || $[14] !== disabled || $[15] !== label || $[16] !== labelColor || $[17] !== labelIcon || $[18] !== labelPlacement || $[19] !== labelVariant || $[20] !== onChange || $[21] !== testId || $[22] !== tooltip) {
        t1 = (t2)=>{
            const { input } = t2;
            return /*#__PURE__*/ jsx(CheckboxInput, _object_spread_props(_object_spread({}, input), {
                label: label,
                labelIcon: labelIcon,
                labelPlacement: labelPlacement,
                labelColor: labelColor,
                labelVariant: labelVariant,
                checked: input.value,
                tooltip: tooltip,
                checkboxTooltip: checkboxTooltip,
                disabled: disabled,
                onChange: onChange || input.onChange,
                testId: testId
            }));
        };
        $[13] = checkboxTooltip;
        $[14] = disabled;
        $[15] = label;
        $[16] = labelColor;
        $[17] = labelIcon;
        $[18] = labelPlacement;
        $[19] = labelVariant;
        $[20] = onChange;
        $[21] = testId;
        $[22] = tooltip;
        $[23] = t1;
    } else t1 = $[23];
    let t2;
    if ($[24] !== name || $[25] !== rest || $[26] !== t1) {
        t2 = /*#__PURE__*/ jsx(Field, _object_spread_props(_object_spread({
            name: name
        }, rest), {
            children: t1
        }));
        $[24] = name;
        $[25] = rest;
        $[26] = t1;
        $[27] = t2;
    } else t2 = $[27];
    return t2;
};
export { CheckboxInput_CheckboxInput as CheckboxInput };
